import { render, staticRenderFns } from "./ForumView.vue?vue&type=template&id=082e6b5a&scoped=true&"
import script from "./ForumView.vue?vue&type=script&lang=js&"
export * from "./ForumView.vue?vue&type=script&lang=js&"
import style0 from "./ForumView.vue?vue&type=style&index=0&id=082e6b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e6b5a",
  null
  
)

export default component.exports